package one.healthium.db.dao

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.withContext
import one.healthium.base.coroutines.IO
import one.healthium.db.AppDatabase
import one.healthium.db.SavedContentEntity

class SavedContentDao(
    private val db: Deferred<AppDatabase>
) {
    fun get(type: SavedContentType): Flow<List<SavedContentEntity>> {
        return flow { emit(db.await()) }
            .flatMapLatest { it.savedContentQueries.selectByType(type.value).asFlow() }
            .mapToList(Dispatchers.IO)
    }

    suspend fun insert(entity: SavedContentEntity) {
        withContext(Dispatchers.IO) {
            db.await().savedContentQueries.insert(entity)
        }
    }

    suspend fun deleteById(id: String) {
        withContext(Dispatchers.IO) {
            db.await().savedContentQueries.deleteById(id)
        }
    }

    suspend fun deleteOldRecentlyEntries() {
        withContext(Dispatchers.IO) {
            db.await().savedContentQueries.deleteRecentlyOldEntries(
                SavedContentType.Recently.value,
                SavedContentType.Recently.value,
                25,
            )
        }
    }
}

enum class SavedContentType(val value: String) {
    Favorite("FAVORITE"),
    Recently("RECENTLY"),
}